"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addUserShownFeatureAnnouncementServiceApi = exports.AddUserShownFeatureAnnouncementRequestBodyApiDomain = void 0;
const class_validator_1 = require("class-validator");
const service_1 = require("../../service");
class AddUserShownFeatureAnnouncementRequestBodyApiDomain extends service_1.ServiceRequestBodyApiDomain {
    constructor(props) {
        super();
        Object.assign(this, props);
    }
}
exports.AddUserShownFeatureAnnouncementRequestBodyApiDomain = AddUserShownFeatureAnnouncementRequestBodyApiDomain;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], AddUserShownFeatureAnnouncementRequestBodyApiDomain.prototype, "featureName", void 0);
// =============================================================================
// API
// =============================================================================
class AddUserShownFeatureAnnouncementServiceApi extends service_1.ServiceApi {
    constructor() {
        super(...arguments);
        this.method = service_1.HttpMethod.POST;
        this.internalPath = "/myinfo/users-feature-announcements-shown/api/v1";
        this.path = "/myinfo/users-feature-announcements-shown/api/v1";
        this.requestContentType = "application/json";
    }
}
exports.addUserShownFeatureAnnouncementServiceApi = new AddUserShownFeatureAnnouncementServiceApi();
exports.addUserShownFeatureAnnouncementServiceApi.assertValidations();
//# sourceMappingURL=add-user-shown-feature-announcement-api-domain.js.map